import { useEffect } from "react";
import { Fab, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";

type Props = {
  editing: boolean;
  onToggle: (next: boolean) => void;
};

export default function CableEditButton({ editing, onToggle }: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && editing) {
        onToggle(false);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [editing, onToggle]);

  return (
    <Tooltip
      title={editing ? "Save / exit edit mode (Esc to cancel)" : "Edit cables"}
    >
      <Fab
        color={editing ? "success" : "primary"}
        onClick={() => onToggle(!editing)}
        sx={{
          position: "fixed",
          right: "calc(env(safe-area-inset-right, 0px) + 16px)",
          bottom: "calc(env(safe-area-inset-bottom, 0px) + 160px)",
          zIndex: 5000,
        }}
      >
        {editing ? <SaveIcon /> : <EditIcon />}
      </Fab>
    </Tooltip>
  );
}
